import { type PropsWithChildren, useCallback } from 'react';
import type { PickupPoint } from '@/shared/api/pickupPoint';
import pinSelectedSource from './assets/pinSelected.svg';
import pinUnselectedSource from './assets/pinUnselected.svg';
import { getPinSrc } from './lib/getPinSrc';
import styles from './PickupAddressMapPin.module.css';

interface PickupAddressMapPinProps extends PropsWithChildren {
    name: string;
    point: PickupPoint;
    isSelected: boolean;
}

export const PickupAddressMapPin = (props: PickupAddressMapPinProps) => {
    const { name, point, isSelected, children } = props;

    const src = getPinSrc(point.serviceType, isSelected);

    const renderPin = useCallback(() => {
        if (isSelected) {
            if (src) {
                return <img className={styles.image} src={src} alt={name} />;
            }

            return <img className={styles.image} src={pinSelectedSource} alt={name} />;
        }

        if (!src) {
            return <img className={styles.image} src={pinUnselectedSource} alt="" />;
        }

        return <img className={styles.image} src={src} alt="" />;
    }, [isSelected, name, src]);

    return (
        <div className={styles.pin}>
            {renderPin()}
            {children}
        </div>
    );
};
